module.exports = __webpack_public_path__ + "img/resources-768.93cfcdf6.jpg";